import { render, staticRenderFns } from "./TableBlock.vue?vue&type=template&id=3e48ac64&scoped=true&"
import script from "./TableBlock.vue?vue&type=script&lang=js&"
export * from "./TableBlock.vue?vue&type=script&lang=js&"
import style0 from "./styles/TableBlock.scss?vue&type=style&index=0&id=3e48ac64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e48ac64",
  null
  
)

export default component.exports